import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/base/Reveal";
import PlanCards from "@/components/feature/PlanCards";
import { revendaGroups } from "@/mocks/revenda";

const TONE_CLASS: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

const SUBTONE_CLASS: Record<string, string> = {
  "da-": "bg-primary-100 text-primary-700",
  cpanel: "bg-secondary-100 text-secondary-700",
};

function subToneClass(key: string): string {
  return key.startsWith("cpanel") ? SUBTONE_CLASS.cpanel : SUBTONE_CLASS["da-"];
}

export default function RevendaPlans() {
  return (
    <section id="planos-revenda" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Planos de revenda"
          badgeIcon="ri-price-tag-3-line"
          title="Escolha o plano de revenda ideal para o seu negócio."
          description="Planos com painel DirectAdmin ou cPanel (WHM) e Softaculous, no Brasil e nos EUA. Do revendedor que está começando à operação que gerencia muitos clientes."
        />

        {revendaGroups.map((group) => (
          <div key={group.key} className="mt-14 first:mt-12">
            <div className="flex flex-col gap-3 border-b border-background-200 pb-5 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${TONE_CLASS[group.tone]}`}
                >
                  <i className={`${group.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-2xl font-bold text-foreground-950">
                  {group.title}
                </h3>
              </div>
              <p className="max-w-xl text-sm text-foreground-600">{group.description}</p>
            </div>

            {group.subGroups.map((subGroup) => (
              <div key={subGroup.key} className="mt-10">
                <div className="flex items-center gap-2.5">
                  <span
                    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide ${subToneClass(subGroup.key)}`}
                  >
                    <i className={subGroup.icon} aria-hidden="true"></i>
                    {subGroup.label}
                  </span>
                  <span className="text-sm text-foreground-500">
                    {subGroup.plans.length} {subGroup.plans.length === 1 ? "plano" : "planos"}
                  </span>
                </div>

                <div className="mt-6">
                  <PlanCards
                    plans={subGroup.plans}
                    columns={subGroup.columns}
                    ctaMessage="Ola! Quero conhecer o"
                    ctaLabel="Quero ser parceiro"
                  />
                </div>
              </div>
            ))}
          </div>
        ))}

        <Reveal>
          <p className="mt-12 text-center text-xs text-foreground-500">
            Os recursos apresentados são configuráveis e podem ser ajustados conforme a necessidade
            da sua operação.
          </p>
        </Reveal>
      </div>
    </section>
  );
}